<template>
  <div class="copyright_box">
                  <div class="pcmain">

<div class="footer_info">
    <ul>
        <li>
            <span class="tiem">版权所有：{{site.business_name}}</span>
            
             <span class="tiem" v-if="site.beianicp">
                  <font v-if="site.beianicp_url">   备案号:  <a :href="site.beianicp_url" target="_blank">{{site.beianicp}}</a></font>
                  <font v-else  >备案号: {{site.beianicp}}</font>
                 </span>
            <span class="tiem pc-item"><a href="/admin/" target="_blank" >管理登陆</a></span>
        </li>
        <li>
            <span class="tiem" v-if="site.address">地址：{{site.address}}</span>
            <span class="tiem"  v-if="site.email">邮箱：{{site.email}}</span>
            <span class="tiem"  v-if="site.mobile" >电话：{{site.mobile}}</span>
            <span class="tiem"  v-if="site.fax" >传真：{{site.fax}}</span>
        </li>
        <li>
            <span class="tiem"  v-if="site.supervise_mobile">纪委监督举报电话：{{site.supervise_mobile}}</span>
        </li>
    </ul>
</div>

                                  <div  class="copyright"  >
                                      <ul  >



                <li v-if="site.copyright"  >CopyRight {{site.copyright}} All Rights Reserved </li>
                <li v-if="site.business_name" >{{site.business_name}}</li>
                <li v-if="site.pc_site_url" >{{site.pc_site_url}}</li>

                <li v-if="site.beianicp" >
                    <a :href="site.beianicp_url" target="_blank">
                <span  v-if="site.beianicp" >  <img :src="site.beianicp_icon" width="20px" />   </span>
                {{site.beianicp}} <!-- 工信部ICP备案查询 -->  </a></li>

                <li v-if="site.beianlian"><a :href="site.beianlian_url" target="_blank">
                <span v-if="site.beianlian">  <img :src="site.beianlian_icon" width="20px" /> </span>
                {{site.beianlian}} <!-- 联网备案查询 -->  </a></li>

                                <!--        <li v-for="(item,index) in linkData"  :key="index" >
                                            <img v-if="item.img" :src="item.img" width="20px"/>
                                            <el-link :href="item.href" target="_blank">
                                                    {{item.title}}
                                            </el-link>
                                        </li> -->
                                    </ul>

                                      </div>
                  </div>
  </div>
</template>
<script>

//     import Storage from '@/components/libs/storage';
// import Site from '@/components/model/site/site'

export default {
  name: "copyright",


  data() {
    return {






    };
  },
  computed: {

  },
props:[

        'site'
],

  created() {
        const that = this;

  },


  methods: {




//     get_site(){
//       const that = this;
//       if(Storage.s_getItem('site') && Storage.s_getItem('site') !== '' ){
//                 let  _site =  Storage.s_getItem('site');

//                 that.site.business_name = _site.business_name
//                 that.site.copyright = _site.copyright
//                 that.site.pc_site_url = _site.pc_site_url
//                 that.site.beianicp = _site.beianicp
//                 that.site.beianicp_url = _site.beianicp_url
//                 that.site.beianicp_icon = _site.beianicp_icon
//                 that.site.beianlian = _site.beianlian
//                 that.site.beianlian_url = _site.beianlian_url
//                 that.site.beianlian_icon = _site.beianlian_icon

// console.log('Site ok  Copyright.vue')

//       }else{
//                   console.log('Site err112  Copyright.vue')
//                   Site.info({}).then(res => {
//                     if(res.status == 1 ){

//                        Storage.s_setItem('site',res.data.result);
//                       // that.get_site();
//                       let  _site = res.data.result;
//                       that.site.business_name = _site.business_name
//                       that.site.copyright = _site.copyright
//                       that.site.pc_site_url = _site.pc_site_url
//                       that.site.beianicp = _site.beianicp
//                       that.site.beianicp_url = _site.beianicp_url
//                       that.site.beianicp_icon = _site.beianicp_icon
//                       that.site.beianlian = _site.beianlian
//                       that.site.beianlian_url = _site.beianlian_url
//                       that.site.beianlian_icon = _site.beianlian_icon
//                     }
//                   }).catch(res => {
//                            console.info('Site.info',  res)
//                   })
//               }
//     },





  }
};
</script>
<style scope>




</style>



// WEBPACK FOOTER //
// src/components/page/tmp/Copyright.vue